import { Typography } from 'antd';
import { LinkProps } from 'antd/lib/typography/Link';
import Link, { LinkProps as NextLinkProps } from 'next/link';
import { PropsWithChildren } from 'react';

const GrispiTypographyNextLink = ({ children, href, ...rest }: PropsWithChildren<LinkProps & NextLinkProps>) => {
    return (
        <div>
            <Typography.Link {...rest}>
                <Link href={href} {...rest}>
                    {children}
                </Link>
            </Typography.Link>
        </div>
    );
};

export default GrispiTypographyNextLink;
